import { useBool, useOnClickOutside } from "../../../sg-core";
import React, { useState, useRef } from "react";
import { Divider, Dropdown, Icon, Menu } from "semantic-ui-react";
import { useLoggedInUser } from "../auth/store/authSelectors";
import { useApplicationConfiguration } from "../configuration/ConfigurationContext";
import LanguageSelect from "./LanguageSelect";


const companies = [
    {
        name: "Demo 2021",
        image: "https://sg-demo-havainnot-test.azurewebsites.net/site-logo.png",
        rdr: "2"
    },
    {
        name: "Koekäyttö 01",
        image: "https://demo01-havainnot-test.azurewebsites.net/site-logo.png",
        rdr: "5dd45fa9-bb15-45c0-bfa7-070210e41775"
    },
    {
        name: "Koekäyttö 02",
        image: "https://demo02-havainnot-test.azurewebsites.net/site-logo.png",
        rdr: "af557d70-f70c-49a1-b24d-a1a282d38cb9"
    }
];



const apps = [
    {
        name: "Auditoinnit",
        image: "https://gate.systemsgarden.com/entries/sovelluskuvake_gate2.aspx?id=590&seq=1647&width=104&height=104",
        guid: "2ca42404-ea49-4c13-847a-d8daff6a0711"
    },
    {
        name: "Havainnot",
        image: "https://gate.systemsgarden.com/entries/sovelluskuvake_gate2.aspx?id=589&seq=1647&width=104&height=104",
        guid: "fd39355f-b1ed-4f25-a5c9-2fa5ebad5de3"
    },
    {
        name: "Työluvat",
        image: "https://gate.systemsgarden.com/entries/sovelluskuvake_gate2.aspx?id=591&seq=1647&width=104&height=104",
        guid: "cd7a8cfd-73f8-4782-ac11-0bd443fe4411"
    }
];



interface TopRightCornerMenuProps { }

const TopRightCornerMenu: React.FC<TopRightCornerMenuProps> = () => {
    const { showTenantSwitch } = useApplicationConfiguration();
    const wrapperElement = useRef<any>();

    const [isOpen, setIsOpen] = useState(false);

    const [changeCompanyMenu, showChangeCompany, hideChangeCompany] = useBool();
    const user = useLoggedInUser();


    const hideMenu = () => {
        setIsOpen(false);
        hideChangeCompany();
    };

    const showMenu = () => setIsOpen(true);


    useOnClickOutside(wrapperElement, hideMenu)


    const menuContent = (
        <Dropdown.Menu id="TopRightCornerMenu" style={{ minWidth: "250px" }}>
            <Dropdown.Header content="Kirjautuneena" />
            <p style={{ padding: "0em 1.125rem", marginBottom: "5px" }}> {user?.fullname} </p>
            <p style={{ padding: "0em 1.125rem" }}> Demo 2021 - <span style={{ color: "#00af48", cursor: "pointer" }} onClick={showChangeCompany}> Vaihda tiliä </span> </p>

            <Dropdown.Divider />
            <Dropdown.Header content="Sovellukset" />
            {apps.map((app) => (
                <Dropdown.Item
                    as="a"
                    key={app.guid}
                    image={app.image}
                    text={app.name}
                    href={`https://gate.systemsgarden.com/direct2?rdr=${app.guid}&polku=/`}
                    onClick={hideMenu}
                />
            ))}

            <Divider hidden />
        </Dropdown.Menu>
    );


    const menuCompanyContent = (
        <Dropdown.Menu id="TopRightCornerMenu" style={{ minWidth: "250px" }} >
            <Dropdown.Header content="Valitse tili" />
            <Dropdown.Divider />
            {companies.map((company) => (
                <Dropdown.Item
                    as="a"
                    key={company.rdr}
                    style={{ alignItems: "center", display: "flex", margin: "5px 0" }}
                    image={{ style: { maxWidth: "30px" }, src: company.image }}
                    text={company.name}
                    href={`https://gate.systemsgarden.com/direct2?rdr=${company.rdr}&polku=/`}
                    onClick={hideMenu}
                />
            ))}

            <Divider hidden />

        </Dropdown.Menu>
    );


    return (
        <div className="TopRightCornerMenu no-print">
            <Menu size="large" secondary>

                <Menu.Item>
                    <LanguageSelect />
                </Menu.Item>

                {showTenantSwitch && (
                    <Menu.Item>
                        <div ref={wrapperElement}>
                            <Dropdown
                                open={isOpen}
                                onOpen={showMenu}
                                trigger={<span>  <Icon name="user circle" size="large" />   </span>}
                                floating
                                labeled
                                className='icon'
                                direction="left"
                            >
                                {changeCompanyMenu ? menuCompanyContent : menuContent}
                            </Dropdown>
                        </div>
                    </Menu.Item>
                )}

            </Menu>
        </div>
    );
};


export default TopRightCornerMenu;


/**
 *
                <Menu.Item>
                    <AppEnvriomentSelect />
                </Menu.Item>
 */